import React, { useContext } from "react";

import {
  AddCard,
  Comment,
  Work,
  AccessTime,
  Delete,
  CancelPresentation,
  CheckBox,
} from "@mui/icons-material";

import {
  Button,
  Card,
  CardContent,
  CardActions,
  Alert,
  Box,
} from "@mui/material/";

import { CustomIcons } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { PermissionContext } from "../../../Components/Context/Context";
import LoadingPage from "../../../Components/Common/Loading/LoadingPage";

const NotesTab = ({
  addDataTab,
  setAddDataTab,
  editDataTab,
  setEditDataTab,
  Editor,
  editorState,
  onEditorChange,
  onSaveShortcut,
  handleCancelDataTabs,
  handleSubmitDataTabs,
  dataCaseNotesAlertsMessages,
  handleDeleteDataTabs,
  setSelectionStyleNote,
  selectionStyleNote,
  listReloading = false,
  isSaving = false,
  isTyping = false,
}) => {
  const { can } = useContext(PermissionContext);
  const canDeleteNotes = can?.("cases", "deletenotes");
  const canAddNotes = can?.("cases", "addnotes");

  const CardNotes = ({
    lawyer,
    createdAt,
    message,
    noteId,
    noteLawyerId,
    noteCaseId,
  }) => {
    return (
      <Card
        sx={{
          minWidth: 275,
          color: "#3f4a5a",
          // border: "1px solid rgba(209, 230, 255, 0.7)",
          background: "rgba(255, 255, 255, 0.55)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          // boxShadow: "0 2px 12px rgba(29, 78, 216, 0.07)",
          borderRadius: "14px",
          overflow: "hidden",
        }}>
        <CardContent
          className="alignItemsAndLeft"
          sx={{ pb: "12px", pt: "15px", px: "16px" }}>
          <Comment
            color="info"
            sx={{ marginRight: "10px", mt: "2px" }}
            className="alignItemsAndLeft"
          />
          <Box
            sx={{
              fontSize: "0.93rem",
              lineHeight: 1.55,
              color: "#324054",
              "& p": { mt: 0, mb: "0.45rem" },
            }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </CardContent>

        <CardActions
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(90deg, #dcebff 0%, #eef6ff 38%, #ffffff 100%)",
            padding: "3px 16px",
            // borderTop: "1px solid #dde8f5",
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              color: "#607086",
              fontSize: "0.84rem",
            }}>
            <Work sx={{ fontSize: "1rem" }} />
            {lawyer && !lawyer.includes("undefined") ? lawyer : ""}

            <AccessTime sx={{ fontSize: "1rem" }} />
            {createdAt}
          </div>

          {/* Botones opcionales */}
          {!editDataTab && (
            <div>
              {/* <Button
                 color="info"
                 size="small"
                 onClick={() => {
                   setEditDataTab(true);
                   setAddDataTab(true);
                   setNoteId(noteId);
                   setSelectionStyleNote(noteId);
                   setNoteLawyerId(noteLawyerId);
                   setNoteCaseId(noteCaseId);
                   handleEditEditorDataTabs(message);
                 }}
               >
                 <Edit />
                 Editar
               </Button> */}
              {canDeleteNotes && (
                <Button
                  color="error"
                  size="small"
                  onClick={() =>
                    handleDeleteDataTabs(noteId, message, "notes", "nota")
                  }>
                  <CustomIcons
                    icon={Delete}
                    width={"20px"}
                    height={"20px"}
                    marginRight={"5px"}
                  />
                  <span className="reOrderTextButton">Eliminar</span>
                </Button>
              )}
            </div>
          )}
        </CardActions>
      </Card>
    );
  };

  return (
    <Box>
      {/* ============================
          EDITOR (IZQUIERDA)
      ============================ */}
      <Box sx={{ textAlign: "right", marginY: "10px" }}>
        {addDataTab !== true && editDataTab !== true && canAddNotes && (
          <CustomButtonPlusIcon
            color={"info"}
            icon={AddCard}
            text={"Agregar Nota"}
            handleFunction={() => setAddDataTab(true)}
            position="start"
            variant={"contained"}
          />
        )}
      </Box>

      {addDataTab ? (
        <Box
          sx={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            mb: "10px",
          }}>
          <div
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              minHeight: "160px",
              marginBottom: "10px",
              borderRadius: "10px",
            }}>
            <Editor
              editorState={editorState}
              onEditorStateChange={onEditorChange}
              onSaveShortcut={onSaveShortcut}
              toolbar={{
                options: ["inline", "fontSize", "list", "textAlign", "history"],
              }}
            />
          </div>

          {(editDataTab || addDataTab) && (
            <div
              style={{
                textAlign: "end",
                marginBottom: "20px",
                gap: 20,
                display: "flex",
                justifyContent: "end",
              }}>
              {addDataTab && !editDataTab && (
                <CustomButtonPlusIcon
                  color={"error"}
                  icon={CancelPresentation}
                  text={"Cancelar Nota"}
                  handleFunction={() => handleCancelDataTabs(false)}
                  position="start"
                  variant={"outlined"}
                />
              )}

              {editDataTab && (
                <CustomButtonPlusIcon
                  color={"error"}
                  icon={CancelPresentation}
                  text={"Cancelar Edición"}
                  handleFunction={() => handleCancelDataTabs(false)}
                  position="start"
                  variant={"outlined"}
                />
              )}

              <CustomButtonPlusIcon
                color={"success"}
                icon={CheckBox}
                text={
                  isSaving
                    ? "GUARDANDO..."
                    : editDataTab
                      ? "GUARDAR EDICIÓN"
                      : "GUARDAR NOTA"
                }
                handleFunction={() => handleSubmitDataTabs("notes", "Nota")}
                position="start"
                variant={"contained"}
                disabled={isSaving || isTyping}
              />
            </div>
          )}
        </Box>
      ) : (
        ""
      )}

      {/* ============================
            NOTAS (DERECHA)
      ============================ */}
      <Box
        sx={{
          maxHeight: "700px",
          overflowY: "auto",
          borderRadius: "10px",
          px: "12px",
          pb: "20px",
        }}>
        {listReloading ? (
          <LoadingPage isLoading={true} heightProp="280px" />
        ) : dataCaseNotesAlertsMessages?.notes?.length > 0 ? (
          dataCaseNotesAlertsMessages?.notes?.map((element, index) => (
            <li
              key={index}
              style={{
                listStyle: "none",
                borderRadius: "10px !important",
                marginTop: "8px",
              }}>
              <CardNotes
                noteCaseId={element.case_id}
                noteLawyerId={element.lawyer_relation?.id}
                lawyer={`${element?.lawyer_relation?.name || ""} ${element?.lawyer_relation?.surname || ""}`.trim()}
                createdAt={element?.date}
                message={element?.message}
                noteId={element?.id}
              />
            </li>
          ))
        ) : (
          <Alert severity="info">Sin notas para mostrar</Alert>
        )}
      </Box>
    </Box>
  );
};

export default NotesTab;
